<template>
    <modal
        :saveAction="saveAction"
        :title="$t(title)"
        :deleteAction="data._id ? data.can_delete ? deleteAction : false : false"
        :id="id"
        :actionButtons="!hideForm"
        size="sm"
        :closeButton="hideForm"
        @shown="shown"
        @hidden="hidden"
    >
        <div class="row">
            <div class="col-12">
                <b-form-group :label="$t('Payment amount')">
                    <money-field :autofocus="true" class="form-control-lg text-center" v-model="data.amount"></money-field>
                </b-form-group>
            </div>
            <div class="col-12">
                <b-form-group :label="$t('Payment method') + '*'">
                    <b-form-select
                        :options="paymentMethods"
                        v-model="data.paymentMethod"
                        :state="validation(data.paymentMethod)"
                    ></b-form-select>
                </b-form-group>
            </div>

            <div class="col-12">
                <b-form-group :label="$t('Date')">
                    <date-picker v-model="data.date" :calendarOptions="calendarOptions"></date-picker>
                </b-form-group>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions } from 'vuex';
import MoneyField from '@/components/MoneyField.vue';
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money";
import DateInput from "@/components/DateInput";
import DatePicker from "@/components/DatePicker";
import { paymentMethods } from '@/filters/payment';

export default {
    name: 'transactions-modal',
    props: {id: String, parent: {type: Object, default: () => ({})}},
    components: {
        Modal,
        MoneyField,
        Money,
        DateInput,
        DatePicker,
    },
    data() {
        return {
            hideForm: false,
            title: 'Add payment',
            errors: {},
            data: {
                paymentMethod: 'cash',
                date: this.$moment().local().format('YYYY-MM-DD'),
            },
            paymentMethods: paymentMethods.map(method => ({
                text: this.$t(method.label),
                value: method.value,
            })),
            calendarOptions: {
                maxDate: new Date()
            },
            customer: {},
            incomeData: {},
        }
    },
    methods: {
        ...mapActions('transactions', ['create', 'patch', 'remove']),
        ...mapActions('customers', {fetchCustomer: 'get'}),
        
        setCustomer(customer) {
            this.customer = customer;
            if (this.customer.balance < 0){
                this.data.amount = Math.abs(this.customer.balance);
            } else {
                this.data.amount = 0;
            }
        },

        shown() {
            this.incomeData = {};
            const { Transaction } = this.$FeathersVuex;
            let data = Transaction.getFromStore('temp');
            if (data) {
                delete data._id;
                this.incomeData = this.$deepCopy(data['invoice']);
                new Transaction({
                    model: {},
                    _id: 'temp'
                });
            }

            this.errors = {};
            if (this.parent.customer){
                this.setCustomer(this.parent.customer);
            }
            else {
                this.fetchCustomer(this.$route.params.id).then(data => {
                    this.setCustomer(data);
                })
            }
            this.data.paymentMethod = this.paymentMethods[0].value;
        },

        hidden() {
            this.data = {};
        },

        deleteAction() {
            this.remove(this.data._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },
        saveAction() {
            let transaction = {
                customerId: this.customer._id,
                amount: this.data.amount,
                paymentMethod: this.data.paymentMethod,
                date: this.data.date,
                status: this.parent._id ? 'transaction' : 'topup',
                parentId: this.parent._id || null,
                invoiceId: this.incomeData._id || null
            };

            let promise, successMessage;

            if (this.data._id) {
                promise = this.patch([this.data._id, this.data]);
                successMessage = 'Funds updated';
            } else {
                promise = this.create(transaction);
                successMessage = 'Funds added';
            }


            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });

            promise.catch(err => {
                console.log(err.message);
                this.errors = err.errors;
                this.$toasted.show(err.message, {
                    theme: "bubble",
                    position: "top-right",
                    duration: 3000
                });
            });
        },

        validation(field) {

            if (this.errors && this.errors[field])
                return false;
            else
                return null
        },

    },

}
</script>
